import { render, staticRenderFns } from "./ConfigIndicator.vue?vue&type=template&id=50f9216e&scoped=true&"
import script from "./ConfigIndicator.vue?vue&type=script&lang=js&"
export * from "./ConfigIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIndicator.vue?vue&type=style&index=0&id=50f9216e&prod&scoped=true&lang=css&"
import style1 from "../style.css?vue&type=style&index=1&id=50f9216e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9216e",
  null
  
)

export default component.exports